<template>
    <v-row justify="center">
        <v-dialog fullscreen v-model="dialog" persistent>
            <v-card>
                <v-card-title class="text-h6" v-if="propAdd == 'tambah'">Tambah E-Learning</v-card-title>
                <v-card-title class="text-h6" v-else>Edit E-Learning</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-row>
                                <v-col cols="12" sm="12" md="8" class="pb-0">
                                    <v-text-field class="w-md-75" outlined dense @focus="() => konfirmResponse.title = ''"
                                        :error-messages="konfirmResponse.title" v-model="paramAdd.title" label="Judul E-Learning"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="pb-0">
                                    <v-autocomplete outlined dense @focus="() => konfirmResponse.category_id = ''"
                                        :error-messages="konfirmResponse.category_id" v-model="category_selected" :items="tutorialCategory"
                                        item-text="tutorial_category_name" item-value="tutorial_category_id" label="Kategori"
                                        no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="8" class="pb-0">
                                    <v-text-field class="w-md-75" outlined dense @focus="() => konfirmResponse.link = ''"
                                        :error-messages="konfirmResponse.link" v-model="paramAdd.link" label="Link"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4" class="pb-0">
                                    <div class="d-flex justify-start align-center">
                                        <div class="d-flex justify-start align-center">
                                            <img width="50" :src="'/assets/tutorial/' + imageDocs" :alt="imageDocs">
                                            <span class="font-weight-bold font-size-14 ml-2" v-if="imageDocs">Google <span
                                                    class="font-weight-regular">{{ textDocs }}</span></span>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="pt-2 pb-0">
                                    <v-textarea outlined dense @focus="() => konfirmResponse.caption = ''"
                                        :error-messages="konfirmResponse.caption" v-model="paramAdd.caption" label="Caption E-Learning" no-resize
                                        height="100"></v-textarea>
                                </v-col>
                                <v-col v-if="paramAdd.link !== ''" cols="12" sm="12" md="6"
                                    class="pb-0 d-flex flex-column justify-center align-center">
                                    <div v-if="embed_src !== ''" class="embed-responsive embed-responsive-16by9 w-100">
                                        <iframe class="embed-responsive-item rounded" width="75%" height="280" :src="embed_src"></iframe>
                                    </div>
                                    <span v-else>
                                        <v-icon>mdi-video-off</v-icon>
                                        <span>Tidak ada video</span>
                                    </span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" outlined @click="batal" class="text-capitalize">Batal</v-btn>
                    <v-btn color="primary" depressed @click="simpan" class="text-capitalize">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
            {{ text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
    data() {
        return {
            formData: new FormData(),
            page: 1,
            limit: "10",
            params: [],
            category_selected: '',
            snackbarClass: "green accent-4",
            snackbar: false,
            text: "",
            embed_src: '',
            timeout: 2000,
            imageDocs: '',
            textDocs: '',
            paramAdd: {
                title: '',
                category_id: '',
                link: '',
                image: '',
                caption: '',
            },
        }
    },
    props: {
        value: Boolean,
        propAdd: String,
        edit: String,
        val: Object
    },
    computed: {
        ...mapState('tutorial', ['konfirmResponse', 'responSukses', 'tutorialCategory', 'imageName']),
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        ...mapActions('tutorial', ['getTutorial', 'addTutorial', 'updateTutorial', 'getTutorialCategoryOption', 'uploadImage']),
        ...mapMutations('tutorial', ['konfirmasiSukses']),
        batal() {
            this.dialog = false
            this.konfirmResponse.title = ''
            this.konfirmResponse.category_id = ''
            this.konfirmResponse.link = ''
            this.konfirmResponse.caption = ''
        },
        async simpan() {
            if (this.paramAdd) {
                this.paramAdd.category_id = this.category_selected;
                if (this.formData.has('image')) {
                    await this.uploadImage(this.formData).then(() => {
                        this.paramAdd.image = this.imageName;
                    })
                }

                if (this.propAdd == 'tambah') {
                    await this.addTutorial(this.paramAdd).then(() => {
                        if (this.responSukses.code == 200) {
                            this.getTutorial({ limit: this.limit, page: 1, params: this.params })
                            this.dialog = false
                            this.reset()
                        }
                    })
                } else {
                    await this.updateTutorial(this.paramAdd).then(() => {
                        if (this.responSukses.code == 200) {
                            this.getTutorial({ limit: this.limit, page: 1, params: this.params })
                            this.dialog = false
                            this.reset()
                        }
                    })
                }
            }
        },
        getVideoUrl(url) {
            if (!this.isYoutubeUrl(url)) {
                this.embed_src = ''
                this.paramAdd.image = ''
                let split = url.split('/');
                let fileId = ''

                //google drive
                if (split[2] == 'drive.google.com' || split[0] == 'drive.google.com') {
                    if(url.includes('folders')){
                        this.paramAdd.image = 'drive.png';
                        this.imageDocs = 'drive.png'
                        this.textDocs = 'Drive Folder'
                        return
                    } else {
                        let matches = url.match(/d\/([a-zA-Z0-9\-_]+)/);
                        if (matches && matches[1]) {
                            fileId = matches[1];
                            this.paramAdd.image = 'https://lh3.googleusercontent.com/d/' + fileId + '=s4000';
                            this.imageDocs = 'drive.png';
                            this.textDocs = 'Drive File';
                            return;
                        } else {
                            this.imageDocs = '';
                            this.textDocs = '';
                            return;
                        }
                    }
                } else {
                    //google docs
                    let matches = url.match(/d\/([a-zA-Z0-9\-_]+)/);
                    fileId = matches[1]
                    if (split[3] == 'document' || split[1] == 'document') {
                        this.paramAdd.image = 'https://lh3.googleusercontent.com/d/' + fileId  + '=s4000';
                        this.imageDocs = 'docs.png'
                        this.textDocs = 'Docs'
                        return
                    }
                    else if (split[3] == 'presentation' || split[1] == 'presentation') {
                        this.paramAdd.image = 'https://lh3.googleusercontent.com/d/' + fileId  + '=s4000';
                        this.imageDocs = 'slides.png'
                        this.textDocs = 'Slides'
                        return
                    }
                    else if (split[3] == 'spreadsheets' || split[1] == 'spreadsheets') {
                        this.paramAdd.image = 'https://lh3.googleusercontent.com/d/' + fileId  + '=s4000';
                        this.imageDocs = 'sheets.png'
                        this.textDocs = 'Sheets'
                        return
                    } else {
                        this.imageDocs = ''
                        this.textDocs = ''
                        return
                    }
                }
            } else {
                var matches = url.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
                if (matches[1].length == 11) {
                    let video_id = url.split('v=')[1]
                    let ampersandPosition = video_id.indexOf('&')
                    if (ampersandPosition != -1) {
                        video_id = video_id.substring(0, ampersandPosition)
                    }
                    this.embed_src = "https://www.youtube.com/embed/" + video_id
                    this.paramAdd.image = 'https://img.youtube.com/vi/' + video_id + '/maxresdefault.jpg'
                } else {
                    this.embed_src = ''
                    this.paramAdd.image = ''
                }
            }

        },
        removeImage() {
            this.image = '';
        },
        reset() {
            this.konfirmasiSukses('')
            this.paramAdd.title = ''
            this.category_selected = ''
            this.paramAdd.link = ''
            this.paramAdd.image = ''
            this.paramAdd.caption = ''
            this.konfirmResponse.title = ''
            this.konfirmResponse.category_id = ''
            this.konfirmResponse.link = ''
            this.konfirmResponse.caption = ''
            this.embed_src = ''
        },
        isYoutubeUrl(str) {
            return str.includes('youtube')
        }
    },
    watch: {
        val() {
            if (this.$refs.inputFile) {
                this.$refs.inputFile.reset()
            }
            this.image = this.val.tutorial_thumbnail
            this.paramAdd.id = this.val.tutorial_id
            this.paramAdd.title = this.val.tutorial_title
            this.paramAdd.image = this.val.tutorial_thumbnail
            this.paramAdd.link = this.val.tutorial_link
            this.paramAdd.caption = this.val.tutorial_caption
            this.category_selected = this.val.tutorial_category_id
            if (this.val.tutorial_link) {
                this.getVideoUrl(this.val.tutorial_link)
            }
        },
        'paramAdd.link': function (val) {
            if (val) {
                this.getVideoUrl(val)
            } else {
                this.embed_src = ''
                this.paramAdd.image = ''
                this.imageDocs = ''
                this.textDocs = ''
            }
        },
        propAdd(val) {
            if (val == 'tambah') {
                this.embed_src = ''
                this.paramAdd.image = ''
            }
        }
    },
    created() {
        this.getTutorialCategoryOption()
    }
}
</script>
